import axios from "axios";

export default axios.create({
  baseURL: "https://food-json-server-vercel.vercel.app",
});
